module.exports = __webpack_public_path__ + "img/UnovaPreview.8d4c2103.png";